//@flow
import {StyleSheet, Platform} from 'react-native';

export default StyleSheet.create({
  title: {
    marginHorizontal: 25,
    marginTop: Platform.OS === 'ios' ? 0 : 15,
    fontSize: Platform.OS === 'ios' ? 19 : 22,
    textAlign: 'center'
  },
  form: {
    marginTop: 60,
    marginBottom: 105,
    marginHorizontal: 20,
  },
});
